import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom'
import { LoginContentPanel } from './LoginContentPanel';
import AuthService from '../../services/AuthService.js'
import FetchService from '../../services/FetchService.js';

export class LoginForm extends Component {
    constructor(props) {
        super(props);

        var redirect = AuthService.isLoggedIn();

        this.state = { 
            redirect: redirect 
        };
         
        //events
        this.onSubmit = this.onSubmit.bind(this); 
        this.btnRecuperar_onClick = this.btnRecuperar_onClick.bind(this);
        var me = this;
        var url = 'api/Sesion/CargarPermisos';
        FetchService.send(url, 'GET', null, me.cargarPermisos.bind(me), me.cargarPermisosError.bind(me));
    }
    cargarPermisos(permisos) {
        this.permisos = permisos;
        this.forceUpdate();
    }
    cargarPermisosError(err) {
        alert(err);
    }
    btnRecuperar_onClick(event) {
        event.preventDefault(); 
        if (this.permisos.RecoveryPasswordUrl) {
            window.open(this.permisos.RecoveryPasswordUrl, "Cambiar contraseña", "width=800,height=600");
        } else {
            //this.props.history.push('/recuperarclave');
            window.location.href = "/recuperarclave";
        }
    } 
    componentDidMount() { 
    } 
    onSubmit(e) {
        var me = this;
        e.preventDefault();
        const data = new FormData(e.target);
        fetch('api/Sesion/IniciarSesion', {
            method: 'POST',
            body: data
        })
            .then(function (response) {
                var x = 0;
                x++;
                if (response.ok) {
                    return response.json();
                }
                else {
                    return response.json();
                }
            })
            .then(function (result) {
                var x = 0;
                x++;
                if (result.error) {
                    alert(result.error);
                } else {
                    //localStorage.setItem('token', JSON.stringify(token)); 
                    me.props.handleLogin(JSON.stringify(result));
                    me.setState({
                        redirect: true
                    });
                }
            })
            .catch(function (err) {
                var x = 0;
                x++;
                alert(err);
            });
    }

    render() {
        if (this.state.redirect) {
            return (<Redirect to={"/home"} />);
        }
        return (
            <div>
                <h4>Inicio de sesión</h4>
                <form id="LoginForm" onSubmit={this.onSubmit}>
                    <div>
                        <LoginContentPanel />
                    </div>
                    <div >
                        <button type="submit" className="btn btn-primary btn-sm">Aceptar</button>&nbsp;
                        <a href="#" onClick={this.btnRecuperar_onClick}>Recuperar contraseña</a>
                    </div>
                </form>
            </div >
        );
    }
}
